import { Collapse as CollapseMUI } from '@mui/material'

import ArrowDownSVG from 'app/assets/icons/listing/green-arrow-round-down.svg'
import ArrowUpSVG from 'app/assets/icons/listing/green-arrow-round-up.svg'
import IconButton from 'app/components/base/IconButton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import useBoolean from 'app/hooks/useBoolean'

interface MakeCollapseProps {
  open?: boolean
  title: string
  isClickDisabled?: boolean
}

const MakeCollapse: RFC<MakeCollapseProps> = ({
  open,
  title,
  isClickDisabled,
  children
}) => {
  const [isOpen, setOpen] = useBoolean(open)

  return (
    <Stack direction="column">
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: 'center',
          cursor: isClickDisabled ? 'inherit' : 'pointer'
        }}
        {...(!isClickDisabled && { onClick: setOpen.toggle })}
      >
        {!isClickDisabled && (
          <IconButton
            size="small"
            disableRipple
            sx={{ pl: 0 }}
            aria-label={
              isOpen ? 'Collapse makes section' : 'Expand makes section'
            }
          >
            {isOpen ? <ArrowUpSVG /> : <ArrowDownSVG />}
          </IconButton>
        )}

        <Text variant="body2">{title}</Text>
      </Stack>

      <CollapseMUI in={isOpen} timeout="auto" unmountOnExit sx={{ pl: 4.75 }}>
        {children}
      </CollapseMUI>
    </Stack>
  )
}

export default MakeCollapse
